import { render, staticRenderFns } from "./form-rubrik.vue?vue&type=template&id=5a2b24c6&"
import script from "./form-rubrik.vue?vue&type=script&lang=js&"
export * from "./form-rubrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports